import { motion } from "framer-motion";

const STEPS = [
  { n: "01", t: "Brief", d: "You send us the release. We map the creator stack, timeline, and success metrics in 48 hours." },
  { n: "02", t: "Seed", d: "We deploy across our internal 2,000+ creator network, micros, mid-tiers, and macros, at direct rates." },
  { n: "03", t: "Amplify", d: "Top-performing UGC gets paid amplification. Playlists, fan pages, and lyric pages compound the moment." },
  { n: "04", t: "Report", d: "Live dashboards, real numbers, weekly performance decks. You see every dollar, every creator, every view." },
];

export default function HowWeRun() {
  return (
    <section data-testid="home-how-we-run" className="relative py-10 md:py-14 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-8">
          <div className="text-xs uppercase tracking-[0.24em] text-zinc-500 mb-4">How we run a campaign</div>
          <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-3xl">
            From brief to chart<br /><span className="italic font-light">in a week, not a quarter.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="border border-white/10 rounded-2xl p-6 hover:border-white/25 hover-lift glow-card"
              data-testid={`how-we-run-step-${s.n}`}
            >
              <div className="text-xs font-mono text-zinc-500">{s.n}</div>
              <div className="mt-4 font-display font-semibold text-2xl tracking-tight">{s.t}</div>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
